import { render } from "./SsoCallback.vue?vue&type=template&id=49a8e6da&scoped=true&lang=pug"
import script from "./SsoCallback.vue?vue&type=script&lang=js"
export * from "./SsoCallback.vue?vue&type=script&lang=js"

import "./SsoCallback.vue?vue&type=style&index=0&id=49a8e6da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a8e6da"]])

export default __exports__